/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_NInputs */

const en_tut_santai_n = /** @type {(inputs: Tut_Santai_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiet mode pauses sounds and games automatically when your status is focus, meeting, or unavailable, and inside focus areas. Celebration sounds always need your browser's permission. Game limits: 20 minutes, 200 moves, 12 players. Music is not played inside KerjaBareng — only the link is shared.`)
};

const id_tut_santai_n = /** @type {(inputs: Tut_Santai_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode tenang otomatis menjeda suara dan permainan saat status Anda fokus, rapat, atau tidak tersedia, dan di area fokus. Suara selebrasi selalu perlu izin browser Anda. Batas permainan: 20 menit, 200 langkah, 12 pemain. Musik tidak diputar di dalam KerjaBareng — yang dibagikan hanya tautannya.`)
};

/**
* | output |
* | --- |
* | "Quiet mode pauses sounds and games automatically when your status is focus, meeting, or unavailable, and inside focus areas. Celebration sounds always need y..." |
*
* @param {Tut_Santai_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_n = /** @type {((inputs?: Tut_Santai_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_n(inputs)
	return en_tut_santai_n(inputs)
});